<template>
  <div class="dictionary-acceptances">
    <transition name="slide" mode="out-in">
      <router-view/>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'dicitionary-acceptances-view'
}
</script>

<style lang="scss" scoped>

</style>
